import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { ToggleOptions, ToggleSection, ToggleTitle } from './SharedNearbyFilterComponents'
import { ToggleButton } from '@elements/form_elements/ToggleButton'
import { NearbyActiveIndicator } from './NearbyActiveIndicator'
import { statusTextShort } from '../StatusSelectButtons'
import StatusIndicator from '@elements/StatusIndicator'

const StyledToggleButton = styled(ToggleButton)`
  justify-content: flex-start;
  line-height: ${size(2)};
`

const ToggleRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: ${size(1.5)};
`

const ShortStatusText = styled.span`
  font-size: ${fontSize('xs')};
  color: rgba(255,255,255,0.6);
  white-space: nowrap;
`

const LookingStatusToggleButton = ({ lookingStatus, text, ...rest }) => {
  const isRightNowSelected = rest?.selected && lookingStatus === 'right_now'
  const containerStyles = {}
  if (isRightNowSelected) containerStyles.backgroundColor = 'rgba(255,255,255,0.25)'
  containerStyles.border = '0.5px solid rgba(255,255,255,0.35)'

  return (
    <StyledToggleButton {...rest}>
      <StatusIndicator
        containerStyles={containerStyles}
        size={size(4.5)}
        status={lookingStatus}
      />
      <ToggleRight>
        {text}
        <ShortStatusText>
          {statusTextShort[lookingStatus]}
        </ShortStatusText>
      </ToggleRight>
    </StyledToggleButton>
  )
}

const LookingStatusFilterSection = ({ value, onChange, isInactive }) => {
  return (
    <ToggleSection>
      <ToggleTitle>
        Their Looking Status
        <NearbyActiveIndicator isActive={value instanceof Set && value.size > 0} />
      </ToggleTitle>
      <ToggleOptions style={{ paddingBottom: size(1), filter: isInactive && 'grayscale(100%)' }} onChange={onChange}>
        <LookingStatusToggleButton
          lookingStatus='browsing'
          name='tempStatus'
          value='browsing'
          text='Browsing'
          selected={value?.has?.('browsing')}
          onChange={(e) => onChange(e, 'tempStatus', 'browsing')}
        />
        <LookingStatusToggleButton
          lookingStatus='right_now'
          name='tempStatus'
          value='right_now'
          text='Right Now'
          selected={value?.has?.('right_now')}
          onChange={(e) => onChange(e, 'tempStatus', 'right_now')}
        />
        <LookingStatusToggleButton
          lookingStatus='meetup'
          name='tempStatus'
          value='meetup'
          text='Meetup'
          selected={value?.has?.('meetup')}
          onChange={(e) => onChange(e, 'tempStatus', 'meetup')}
        />
        <LookingStatusToggleButton
          lookingStatus='chatting'
          name='tempStatus'
          value='chatting'
          text='Chatting'
          selected={value?.has?.('chatting')}
          onChange={(e) => onChange(e, 'tempStatus', 'chatting')}
        />
        <LookingStatusToggleButton
          lookingStatus='romance'
          name='tempStatus'
          value='romance'
          text='Romance'
          selected={value?.has?.('romance')}
          onChange={(e) => onChange(e, 'tempStatus', 'romance')}
        />
      </ToggleOptions>
    </ToggleSection>
  )
}

export { LookingStatusFilterSection }
